"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @param {Recover} recover A reference of the Recover class
 * @class AppTexts
 * @classdesc Returns Application Texts Objects
 */
var AppTexts = /** @class */ (function () {
    function AppTexts(recover) {
        var _this = this;
        this.recover = recover;
        /**
         *
         *
         * @memberof AppTexts
         * @returns { SuccessfulIndexAppTexts} Returns a message and an array of all Application Texts
         * @description Returns an index of all Application Texts
         */
        this.index = function () {
            return _this.recover.request("/app_texts", "GET", null, null);
        };
        /**
         *
         *
         * @memberof AppTexts
         * @returns { SuccessfulCreateAppTexts } Returns a message and the newly created Application Text
         * @property {AppTextsBody} appText A JSON with the fields usage_key(String) and body(string)
         * @description Creates a new Application Text
         */
        this.create = function (appText) {
            return _this.recover.request("/app_texts", "POST", appText, null);
        };
        /**
         *
         *
         * @memberof AppTexts
         * @returns { SuccessfulGetAppTexts } Returns a message and a single Application Text.
         * @property {number} id A reference to a single Application Text
         * @description Get a singular Application Text
         */
        this.get = function (id) {
            return _this.recover.request("/app_texts/" + id, "GET", null, null);
        };
        /**
         *
         *
         * @memberof AppTexts
         * @returns { SuccessfulEditAppTexts } Returns a message and the edited Application Text
         * @property {number} id A reference to a single Application Text
         * @property {AppTextsBody} appText A JSON with the fields usage_key(String) and body(string)
         * @description Edit a singular Application Text
         */
        this.edit = function (id, appText) {
            return _this.recover.request("/app_texts/" + id, "PUT", appText, null);
        };
    }
    return AppTexts;
}());
exports.default = AppTexts;
